module.exports = __webpack_public_path__ + "161d0b2c6caca9d1d0de72144001a465.svg";